module.exports = __webpack_public_path__ + "static/media/intro-video-en.49c447aa.mp4";